import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=9b796316&scoped=true"
import script from "./CookieConsent.vue?vue&type=script&lang=js"
export * from "./CookieConsent.vue?vue&type=script&lang=js"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=9b796316&prod&lang=scss"
import style1 from "./CookieConsent.vue?vue&type=style&index=1&id=9b796316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b796316",
  null
  
)

export default component.exports